module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/lviv-kyiv-c810fc6a7ff9c6bd7cf0fc136f4ba71a.png";